(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({ note: event.target.value });
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"]) return;
  try {
    
  (()=>{
    // Select the node that will be observed for mutations
    const targetNode = document.getElementById("MainContent");

    // Options for the observer (which mutations to observe)
    const config = {childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if(document.querySelectorAll('.NiceSelectOverwrites:not(.setcustom)').length > 0){
          document.querySelectorAll('.NiceSelectOverwrites:not(.setcustom)').forEach((node)=>{node.dispatchEvent(new Event('change'));node.classList.add('setcustom')})
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  })();
  (()=>{
    var oldRondellHtml = ''
    setInterval(()=>{
      const rondell = document.querySelector('#rondellCarousel')
      if(rondell != null){
        var newHtml = ''
        var mobileHtml = ''
        var thumbs = ''
        rondell.querySelectorAll('.rondell-item-crop').forEach((node,index)=>{
          if(index < 8){
            var image = node.querySelector('img')
            var video = node.querySelector('video')
            if(video != null){
              var newImage = "<img src="+video.getAttribute('poster')+" loading='lazy'>"
              newHtml += document.querySelector('#images-observed-desk').innerHTML.replaceAll('@content@',newImage).replaceAll('@src@',video.querySelector('source').getAttribute('src')).replaceAll('@active@',(index == 0 ? 'is-active': '')).replaceAll('@index@','d'+index)
              mobileHtml += document.querySelector('#images-observed-mobile').innerHTML.replaceAll('@content@',newImage).replaceAll('@src@',video.querySelector('source').getAttribute('src')).replaceAll('@active@',(index == 0 ? 'is-active': '')).replaceAll('@index@','m'+index)
              thumbs += document.querySelector('#images-observed-thumb').innerHTML.replaceAll('@content@',newImage).replaceAll('@src@',video.querySelector('source').getAttribute('src')).replaceAll('@active@',(index == 0 ? 'is-active': '')).replaceAll('@index@','m'+index)
            }
            else if(image != null){
              var newImage = "<img src="+image.getAttribute('src')+" loading='lazy'>"
              newHtml += document.querySelector('#images-observed-desk').innerHTML.replaceAll('@content@',newImage).replaceAll('@src@',image.getAttribute('src')).replaceAll('@active@',(index == 0 ? 'is-active': '')).replaceAll('@index@','d'+index)
              mobileHtml += document.querySelector('#images-observed-mobile').innerHTML.replaceAll('@content@',newImage).replaceAll('@src@',image.getAttribute('src')).replaceAll('@active@',(index == 0 ? 'is-active': '')).replaceAll('@index@','m'+index)
              thumbs += document.querySelector('#images-observed-thumb').innerHTML.replaceAll('@content@',newImage).replaceAll('@src@',image.getAttribute('src')).replaceAll('@active@',(index == 0 ? 'is-active': '')).replaceAll('@index@','m'+index)
            }
          }
        })
        if(oldRondellHtml != newHtml){
          document.querySelector('.product-media-wrapper-desk').innerHTML = newHtml
          var newMobileGalleryHtml = document.querySelector('#images-observed-carousel').innerHTML.replace('@media@',mobileHtml).replace('@thumbs@',thumbs)
          document.querySelector('media-gallery').outerHTML = newMobileGalleryHtml
          oldRondellHtml = newHtml
          refreshFsLightbox();
        }
      }
    },500)
  })();
  (()=>{
    const targetNode = document.querySelector('.product-info-main')
    const config = {childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if(document.querySelector('.trustblox-1-timer-wrap') != null){
          var fragment = document.createDocumentFragment();
          fragment.appendChild(document.querySelector('.trustblox-1-timer-wrap'));
          document.querySelector('product-form.product-form').prepend(fragment)
          observer.disconnect()
        }
      }
    }
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  })();

  } catch(e) { console.error(e); }
})();
})();
